import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BalanceService } from 'src/app/core/services/balance.service';
import { IdentityService } from 'src/app/core/services/identity.service';

@Component({
  selector: 'app-collect-options',
  templateUrl: './collect-options.component.html',
  styleUrls: ['./collect-options.component.scss']
})
export class CollectOptionsComponent implements OnInit {
  constructor(private router: Router, private balanceService: BalanceService, private indentity: IdentityService) {}

  isGenerated: boolean = false;
  renderWarn: boolean = false;
  loading: boolean = false;
  isResponsible: boolean;
  isCommerce: boolean;

  async ngOnInit() {
    this.loading = true;
    this.isResponsible = this.indentity.isRolResponsible();
    this.isCommerce = this.indentity.isCommerce();
    try {
      const bankInfo =
        localStorage.getItem('bankInfo') !== null
          ? JSON.parse(localStorage.getItem('bankInfo'))
          : <AccountInfo>await this.balanceService.cashIn();
      this.isGenerated = bankInfo.cbu !== '' ? true : false;
      this.renderWarn = this.isGenerated ? true : false;
    } catch (error) {
      this.isGenerated = false;
      this.loading = false;
    }
    this.loading = false;
  }

  goToQr(url: string) {
    let currentUrl = this.router.url;
    localStorage.setItem('url', currentUrl);
    this.navigate(url);
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }
}

interface AccountInfo {
  alias: string;
  cbu: string;
  ingresoRapipago: boolean;
  tipoCuenta: string;
}
